import { Constants } from "appConstants";
import { BaseDetailsContent, HeadingDetails, Loading } from "components";
import { Customer } from "models/customer/Customer";
import { CustomerDocumentType, CustomerFields } from "models/customer/types";
import { useEffect, useMemo, useState } from "react";

import { MaskHelper } from "helpers";
import useStandardToast from "hooks/useStandardToast";
import { useNavigate, useParams } from "react-router-dom";
import { CustomerService } from "services";
import "../styles.scss";

export default function CustomerDetails() {
	const { id } = useParams();
	const navigate = useNavigate();
	const [customer, setCustomer] = useState<Customer | undefined>(undefined);
	const [isIndividualPerson, setIsIndividualPerson] = useState<boolean>();
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const { showErrorToast } = useStandardToast();

	const customerService = new CustomerService();

	const cleanCustomer = useMemo(() => {
		if (!customer) return {};
		return {
			customerInfo: {
				[isIndividualPerson ? CustomerFields.NAME : CustomerFields.LEGAL_NAME]:
					customer?.[CustomerFields.NAME],
				[CustomerFields.DOCUMENT]: MaskHelper.cpfCnpj(
					customer[CustomerFields.DOCUMENT]
				),
				[CustomerFields.EMAIL]: customer?.[CustomerFields.EMAIL],
				[CustomerFields.PHONE]: customer?.[CustomerFields.PHONE]
			}
		};
	}, [customer]);

	useEffect(() => {
		setIsLoading(true);
		customerService
			.getCustomerDetails(String(id))
			.then((customerResponse: Customer) => {
				setCustomer(customerResponse);
				setIsIndividualPerson(
					customerResponse?.[CustomerFields.DOCUMENT_TYPE] ===
						CustomerDocumentType.CPF
				);
			})
			.catch(() => {
				navigate("/backoffice/customers");
				showErrorToast(Constants.strings.errors.failedToGetCustomerDetails);
			})
			.finally(() => setIsLoading(false));
	}, [id]);

	return (
		<div className="customer-page">
			{!isLoading ? (
				customer && (
					<>
						<HeadingDetails
							title={customer?.[CustomerFields.NAME]}
							showEditButton={false}
						/>
						<div className="customer-panel">
							<BaseDetailsContent
								data={cleanCustomer}
								mainPanelFieldNames={{
									customerInfo: Constants.strings.fields.customerInfo,
									[isIndividualPerson
										? CustomerFields.NAME
										: CustomerFields.LEGAL_NAME]: isIndividualPerson
										? Constants.strings.fields[CustomerFields.NAME]
										: Constants.strings.fields[CustomerFields.LEGAL_NAME],
									[CustomerFields.DOCUMENT]: isIndividualPerson
										? Constants.strings.fields[CustomerDocumentType.CPF]
										: Constants.strings.fields[CustomerDocumentType.CNPJ],
									[CustomerFields.EMAIL]:
										Constants.strings.fields[CustomerFields.EMAIL],
									[CustomerFields.PHONE]: Constants.strings.fields.phone
								}}
								mainPanelFields={["customerInfo"]}
							/>
						</div>
					</>
				)
			) : (
				<div className="customer-list-loading">
					<Loading type="primary" size={75} />
				</div>
			)}
		</div>
	);
}
